import React from "react";
import { Box } from "@chakra-ui/react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import ImageSlide from "./ImageSlide";
import { useIsMobile } from "../default/ResponsiveUtils";

const CarouselComponent = ({ slides }) => {
  const isMobile = useIsMobile();

  return (
    <Carousel
      width={isMobile ? "28rem" : "60rem"}
      autoPlay={true}
      infiniteLoop={true}
      showStatus={false}
      transitionTime={1000}
    >
      {slides.map((slide, index) => (
        <Box key={index}>
          <ImageSlide {...slide} />
        </Box>
      ))}
    </Carousel>
  );
};

export default CarouselComponent;
